import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { auth } from './firebase/config';
import { onAuthStateChanged } from 'firebase/auth';
import Results from './pages/Results';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Matches from './pages/Matches';
import Deposits from './pages/Deposits';
import Withdrawals from './pages/Withdrawals';
import Users from './pages/Users';
import Settings from './pages/Settings';
import PasswordResets from './pages/PasswordResets';
import Videos from './pages/Videos';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    });
    return unsub;
  }, []);

  if (loading) return (
    <div style={{
      background: '#0a0a1a', height: '100vh',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      color: '#f4c430', fontSize: 24
    }}>
      Loading...
    </div>
  );

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={!user ? <Login /> : <Navigate to="/" />} />
        <Route path="/" element={user ? <Dashboard /> : <Navigate to="/login" />} />
        <Route path="/matches" element={user ? <Matches /> : <Navigate to="/login" />} />
        <Route path="/deposits" element={user ? <Deposits /> : <Navigate to="/login" />} />
        <Route path="/withdrawals" element={user ? <Withdrawals /> : <Navigate to="/login" />} />
        <Route path="/users" element={user ? <Users /> : <Navigate to="/login" />} />
        <Route path="/settings" element={user ? <Settings /> : <Navigate to="/login" />} />
        <Route path="/results" element={user ? <Results /> : <Navigate to="/login" />} />
        <Route path="/password-resets" element={user ? <PasswordResets /> : <Navigate to="/login" />} />
        <Route path="/videos" element={user ? <Videos /> : <Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;